import React from 'react'
import Tappable from 'react-tappable'
import Image from 'components/image'
import Link from 'components/link'
import { SHOW_SEARCH_BAR } from 'shared/constants'
import * as css from './search-button.scss'

const SEARCH_ICON =
  'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2222%22%20height%3D%2222%22%20viewBox%3D%220%200%2022%2022%22%3E%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Cpath%20d%3D%22M26%2026H-4V-4h30z%22%2F%3E%3Cpath%20fill%3D%22%234D4D4D%22%20d%3D%22M14.727%2013.836l-.347-.345a8.137%208.137%200%200%200%201.972-5.315A8.176%208.176%200%200%200%208.176%200a8.176%208.176%200%201%200%200%2016.351%208.139%208.139%200%200%200%205.315-1.97l.347.345v.996L20.125%2022%2022%2020.125l-6.274-6.29h-.999zm-6.55%200a5.66%205.66%200%201%201%205.66-5.66%205.66%205.66%200%200%201-5.66%205.66z%22%20opacity%3D%22.54%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E'

class SearchButton extends React.Component {
  static propTypes = {}

  render() {
    return (
      <Tappable classes={{ active: css.active }}>
        <Link onClick={this.handleClick} rel="nofollow">
          <Image alt="search-icon" src={SEARCH_ICON} />
        </Link>
      </Tappable>
    )
  }

  handleClick() {
    PubSub.publish(SHOW_SEARCH_BAR)
  }
}

export default SearchButton
